// src/App.js
import React from 'react';
import EnigmaMachine from './components/EnigmaMachine';

function App() {
  return (
    <div className="App">
      <EnigmaMachine />
    </div>
  );
}

export default App;